import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  getSession,
  getHasNotActivatedSub,
  // getIsWhitelisted,
} from '../utils/session';
import * as routes from '../routes';
import SessionExpireModal from '../components/common/modals/SessionExpireModal';
import useMouseflowQueue from '../hooks/useMouseflowQueue';
import { useGetCustomerQuery } from '../redux/customersApi';
import { identifyGladlyUser, onGladlyReady } from '../utils/gladly';

const AuthProvider = ({ children }) => {
  const [wasMouseflowCustomerSet, setWasMouseflowCustomerSet] = useState(false);
  const session = getSession();
  const hasNotActivatedSub = getHasNotActivatedSub();
  const mouseflowQueue = useMouseflowQueue();
  const { data: customer } = useGetCustomerQuery(undefined, { skip: !session });
  let navigate = useNavigate();

  // set recharge customer id in mouseflow
  useEffect(() => {
    if (!wasMouseflowCustomerSet && session?.customerId) {
      setWasMouseflowCustomerSet(true);
      mouseflowQueue.push(['setVariable', 'customer', session.customerId]);
    }
  }, [
    session?.customerId,
    mouseflowQueue,
    wasMouseflowCustomerSet,
    setWasMouseflowCustomerSet,
  ]);

  // identify the logged-in customer to Gladly chat once the SDK is ready
  useEffect(() => {
    if (!customer?.email) {
      return;
    }
    onGladlyReady(() =>
      identifyGladlyUser({
        email: customer.email,
        name: `${customer.first_name || ''} ${customer.last_name || ''}`.trim(),
      }),
    );
  }, [customer?.email, customer?.first_name, customer?.last_name]);

  useEffect(() => {
    if (!session) {
      return navigate(routes.LOGIN);
    }
    if (
      hasNotActivatedSub &&
      window.location.pathname !== routes.DEVICE_ACTIVATION
    ) {
      const currentSearchParams = new URLSearchParams(window.location.search);
      return navigate(
        `${routes.DEVICE_ACTIVATION}?${currentSearchParams.toString()}`,
      );
    }
    // if (
    //   session &&
    //   !getIsWhitelisted() &&
    //   window.location.pathname !== routes.DEVICE_ACTIVATION
    // ) {
    //   console.log('not whitelisted');
    //   return navigate(routes.LOGIN);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
      <SessionExpireModal />
    </>
  );
};

export default AuthProvider;
